import React from 'react';
import UserAvatar from '../common/UserAvatar';
import moment from 'moment';

const tableConfig = (props, verifyPayment) => ({
    columns: [
        {
            title: 'Invoice ID', field: 'invoice_id', filterAndSearch: true,
            render: rowData => <div>{(rowData.order.invoice_id) || "-"}</div>
        },
        {
            title: 'Amount', field: 'amount', filterAndSearch: true,
            render: rowData => <div>{('₹ ' + rowData.amount) || "-"}</div>
        },
        {
            title: 'Date & Time', field: 'order_local_date', filterAndSearch: true,
            render: rowData => <div>{(moment(rowData.date_system).local().format('YYYY-MM-DD hh:mm A')) || "-"}</div>
        },
        {
            title: 'Status', field: 'payment_status', filterAndSearch: true,
            render: rowData => (
                <>
                    {rowData.payment_status == 'PAID' && <span style={{ color: '#28a745' }} >RECEIVED</span>}
                    {rowData.payment_status == 'UNPAID' && <span style={{ color: '#1890ff' }} >{rowData.payment_status}</span>}
                    {rowData.payment_status == 'FAILED' && <span style={{ color: '#f58634' }} >{rowData.payment_status}</span>}
                </>
            )
        },
        {
            title: 'Actions', field: '', filterAndSearch: false,
            render: rowData => (
                    <div className={`text-capitalize`} style={{ color: '#f58634', padding: 0}}>
                        <button className={`verifybutton text-capitalize`} style={{ width: 'fit-content', padding: '5px 16px'}} onClick={() => { verifyPayment(rowData.order_id) }}>
                            { rowData.payment_status == 'FAILED' ? 'Verify' : 'Verify again' }
                            </button>
                    </div>
            )
        },
    ],
})

export const data = [
    // {
    //     "invoice_id": "24EF0003664",
    //     "amount": "58.4",
    //     "order_local_date": `${new Date()}`,
    //     "payment_status": 'pending',
    // },
];

export default tableConfig;